import React from 'react';
import { styled } from '@mui/material/styles';
import {Box, Grid} from '@material-ui/core';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Highcharts, { Point } from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
//import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import {MetaTags} from 'react-meta-tags';
import axios from 'axios';
import {API_URL} from '../utils/EnvVars';
import { makeStyles } from '@material-ui/core/styles';
import Header from "./HeaderMy";
import LeftDrawer from "../components/LeftDrawer";
import '../styles/bizofficer-a.css';

const useStyles = makeStyles((theme) => ({
	content: {
	  [theme.breakpoints.up('md')]: {
		marginLeft:240,
		marginTop:60,
	  },
	  padding: theme.spacing(1),
	},
  }));

// const chartAbc = {          
// 	series: [70],
// 	options: {
// 	  colors:['#279411'],	
// 	  chart: {
// 		height: 350,
// 		type: 'radialBar',
// 	  },
// 	  plotOptions: {
// 		radialBar: {
// 		  hollow: {
// 			size: '70%',
// 		  }
// 		},
// 	  },
// 	  labels: ['Correct Answer: 7/30'],
// 	},
//   };

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
	height: 10,
	borderRadius: 5,
	[`&.${linearProgressClasses.colorPrimary}`]: {
	  backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
	},
	[`& .${linearProgressClasses.bar}`]: {
	  borderRadius: 5,
	  backgroundColor: theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8',
	},
  }));  
  

  export default function Execute() {
	const classes = useStyles();
	// check if logged in
	if(localStorage.getItem('etlStudentObj')===null){
		window.location.href='login';
	}
	var etlStudentObj = JSON.parse(localStorage.getItem('etlStudentObj'));
	const [myData, setMyData] = React.useState({}); 
	const [pageLoading, setPageLoading] = React.useState(true); 

	const [progressBar, setProgressBar] = React.useState(0);
	const [progressBarFlag, setProgressBarFlag] = React.useState(0);
	const [progressBarColor, setProgressBarColor] = React.useState('red');
	const [progressBarRemarks, setProgressBarRemarks] = React.useState('');

	const [chartOneData, setChartOneData] = React.useState({credits: false,chart:{type: 'pie',height: 325},title:{text: ''},subtitle: {text: ''},caption: {text: ''},tooltip: {valueSuffix: '%'},plotOptions : {pie: {allowPointSelect: true,cursor: 'pointer',dataLabels: {distance:-30,style: {fontSize: '12px',textOutline: 0},enabled: true,format: '{point.y} %'}}},series: [{showInLegend: true,name: '',data: []}]});
	const [chartTwoData, setChartTwoData] = React.useState({credits: false,chart: {type: 'column',height: 325},title: {text: ''},caption: {text: ''},tooltip: {valueSuffix: ''},xAxis: {categories: [],},yAxis: {title: {text: ''},},plotOptions:{column: {	threshold: 0, dataLabels: {enabled: true,formatter: function() {return this.y < 0 ? -(this.y) + '' : this.y + ''}}}},series: [{showInLegend: false,name: '',title:null,data: []}]});
	const [chartThreeData, setChartThreeData] = React.useState({credits: false,chart: {type: 'column',height: 325},title: {text: ''},caption: {text: ''},tooltip: {formatter: function () { var time = this.y; var hours=Math.floor(time/3600); if(hours<10){hours='0'+hours;} var mins=Math.floor(time % 3600 / 60); if(mins<10){mins='0'+mins;} var secs=Math.floor(time % 3600 % 60); if(secs<10){secs='0'+secs;} return this.x+" "+hours+':'+mins+':'+secs; }},xAxis: {categories: [],},yAxis: {title: {text: ''},},plotOptions:{column: {	threshold: 0, dataLabels: {enabled: true,formatter: function () { var time = this.y; var hours=Math.floor(time/3600); if(hours<10){hours='0'+hours;} var mins=Math.floor(time % 3600 / 60); if(mins<10){mins='0'+mins;} var secs=Math.floor(time % 3600 % 60); if(secs<10){secs='0'+secs;} return hours+':'+mins+':'+secs; }}}},series: [{showInLegend: false,name: '',title:null, data: []}]});
	const [chartFourData, setChartFourData] = React.useState({credits: false,chart:{type: 'pie',height: 325},title:{text: 'Time'},subtitle: {text: ''},caption: {text: ''},tooltip: {valueSuffix: '%'},plotOptions : {pie: {allowPointSelect: true,cursor: 'pointer',dataLabels: {distance:-30,style: {fontSize: '12px',textOutline: 0},enabled: true,format: '{point.y} %'}}},series: [{showInLegend: true,name: '',data: []}]});
	const [chartFiveData, setChartFiveData] = React.useState({credits: false,chart: {type: 'column',height: 325},title: {text: 'Average Time'},caption: {text: ''},tooltip: {formatter: function () { var time = this.y; var hours=Math.floor(time/3600); if(hours<10){hours='0'+hours;} var mins=Math.floor(time % 3600 / 60); if(mins<10){mins='0'+mins;} var secs=Math.floor(time % 3600 % 60); if(secs<10){secs='0'+secs;} return this.x+" "+hours+':'+mins+':'+secs; }},xAxis: {categories: [],},yAxis: {title: {text: ''},},plotOptions:{column: {	threshold: 0, dataLabels: {enabled: true,formatter: function () { var time = this.y; var hours=Math.floor(time/3600); if(hours<10){hours='0'+hours;} var mins=Math.floor(time % 3600 / 60); if(mins<10){mins='0'+mins;} var secs=Math.floor(time % 3600 % 60); if(secs<10){secs='0'+secs;} return hours+':'+mins+':'+secs; }}}},series: [{showInLegend: false,name: '',title:null, data: []}]});
	const [chartSixData, setChartSixData] = React.useState({credits: false,chart:{type: 'pie',height: 325},title:{text: 'Correctly attempted questions wise'},subtitle: {text: ''},caption: {text: ''},tooltip: {valueSuffix: '%'},plotOptions : {pie: {allowPointSelect: true,cursor: 'pointer',dataLabels: {distance:-30,style: {fontSize: '12px',textOutline: 0},enabled: true,format: '{point.y} %'}}},series: [{showInLegend: true,name: '',data: []}]});
	const [chartSevenData, setChartSevenData] = React.useState({credits: false,chart:{type: 'pie',height: 325},title:{text: 'Marks wise'},subtitle: {text: ''},caption: {text: ''},tooltip: {valueSuffix: '%'},plotOptions : {pie: {allowPointSelect: true,cursor: 'pointer',dataLabels: {distance:-30,style: {fontSize: '12px',textOutline: 0},enabled: true,format: '{point.y} %'}}},series: [{showInLegend: true,name: '',data: []}]});
	const [chartEightData, setChartEightData] = React.useState({credits: false,chart:{type: 'pie',height: 300},title:{text: ''},subtitle: {text: ''},caption: {text: ''},tooltip: {valueSuffix: '%'},plotOptions : {pie: {allowPointSelect: true,cursor: 'pointer',dataLabels: {distance:-30,style: {fontSize: '12px',textOutline: 0},enabled: true,format: '{point.y} %'}}},series: [{showInLegend: true,name: '',data: []}]});


	const authResult = new URLSearchParams(window.location.search); 
	const testId = authResult.get('testId');
	const [value, setValue] = React.useState('1');

	const deviceType = authResult.get('device_type');
	if(deviceType && deviceType.length>0){
	  localStorage.setItem("deviceType", deviceType);
	}
	
	const handleChange = (event, newValue) => { //taboneboxid
		if(newValue==1){
		  document.getElementById('taboneboxid').style.display="";
		  document.getElementById('tabtwoboxid').style.display="none";
		  document.getElementById('tabthreeboxid').style.display="none";
		}else if(newValue==2){
		  document.getElementById('taboneboxid').style.display="none";
		  document.getElementById('tabtwoboxid').style.display="";
		  document.getElementById('tabthreeboxid').style.display="none";
		}else if(newValue==3){
		  document.getElementById('taboneboxid').style.display="none";
		  document.getElementById('tabtwoboxid').style.display="none";
		  document.getElementById('tabthreeboxid').style.display="";
		}else if(newValue==4){
		  window.location.href="testview?testId=st"+testId;
		}	
		setValue(newValue);
	  };
  

	React.useEffect(() => {		
		getApiData();
	}, []); 

	async function getApiData(){
		let axiosHeader = {
			headers:{
				'Content-Type': 'multipart/mixed',
				'loginId': etlStudentObj.loginId,
				'token': etlStudentObj.token,
				'device': 'web'
			}
		};
		axios.get(API_URL+'/analytics?testSession='+testId, axiosHeader) 
		   .then(response => {
				setPageLoading(false);
			if(response && response.status===200 && response.data ){
				setMyData(response.data);

				if(response.data.progressBarObj && response.data.progressBarObj.percentage){
					setProgressBar(response.data.progressBarObj.percentage);	
					setProgressBarFlag(1);		
					setProgressBarColor(response.data.progressBarObj.barColor);
					setProgressBarRemarks('');
					if(response.data.progressBarObj.barColor==='green'){
						setProgressBarRemarks('Well done. Move to competitive mode');
					}else if(response.data.progressBarObj.barColor==='orange'){
						setProgressBarRemarks('Good progress but still continue learning');
					}else{
						setProgressBarRemarks('Not upto mark. Continue learning');
					}
				}

				setChartOneData({ series: [{ data: response.data.overallPerformanceList }] });
				setChartTwoData({ xAxis: [{ categories: ["Total Marks","Marks Obtained"] }] });
				setChartTwoData({ series: [{ data: [{"y":response.data.fullMarks,"color":"#46d39a"},{"y":response.data.marksObtain,"color":"#e55759"}] }] });
				setChartThreeData({ xAxis: [{ categories: ["Total Time","Time Spent","Remaining Time"] }] });
				setChartThreeData({ series: [{ data: [{"y":response.data.totalTimeSeconds,"color":"#46d39a"},{"y":response.data.timeSpent,"color":"#e55759"},{"y":response.data.timeRemaining,"color":"#4198d7"}] }] });

				setChartFourData({ series: [{ data: [{"y":response.data.timeTakenPercent,"name":"Time Taken","color":"#46d39a"},{"y":response.data.timeRemainingPercent,"name":"Time Ramaining","color":"#e55759"}] }] });
				setChartFiveData({ xAxis: [{ categories: ["Available Time","Time taken on attempted questions"] }] });
				setChartFiveData({ series: [{ data: [{"y":response.data.totalTimeSeconds,"color":"#46d39a"},{"y":response.data.timeSpent,"color":"#e55759"}] }] });

				setChartSixData({ series: [{ data: [{"y":response.data.questionWiseKnowledgeUnknown,"name":"Unknown","color":"#e55759"},{"y":response.data.questionWiseKnowledgeKnown,"name":"Known to you","color":"#46d39a"}] }] });
				setChartSevenData({ series: [{ data: [{"y":response.data.marksWiseKnowledgeUnknown,"name":"Unknown","color":"#e55759"},{"y":response.data.marksWiseKnowledgeKnown,"name":"Known to you","color":"#46d39a"}] }] });
				setChartEightData({ series: [{ data: [{"y":response.data.percentageCorrectAttemptedQuestions,"name":"Correct Questions","color":"#46d39a"},{"y":response.data.percentageIncorrectAttemptedQuestions,"name":"Incorrect Questions","color":"#e55759"}] }] });
			
			} else if (response && response.data && response.data.responseTxt === "invalidToken") {
				window.localStorage.removeItem("etlStudentObj");
				window.localStorage.clear();
				window.location.href = 'logout';			
			
			}
	   })

	}

	const ProgressBarGraph = styled(LinearProgress)(({ theme }) => ({
		height: 10,
		borderRadius: 5,
		[`&.${linearProgressClasses.colorPrimary}`]: {
		  backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
		},
		[`& .${linearProgressClasses.bar}`]: {
		  borderRadius: 5,
		  backgroundColor: theme.palette.mode === 'light' ? progressBarColor : '#308fe8',
		},
	  }));  

	return (
		<div> 
				<MetaTags>
            		<title>Analytics</title>
          		</MetaTags>
				
				<Header />	
				<LeftDrawer />
				<main className={classes.content}>
				
				{pageLoading?<LinearProgress />:null}
				
				<Box style={{marginBottom:150, marginLeft:20, marginRight:20}}>	

					<Box mt={1}>
							<Grid container spacing={2}>
								<Grid item md={6} sm={12} xs={12}>
									<h3 className="heading" >{myData.testName}</h3>
									<h4 style={{color:'#f50057'}}>Date: {myData.submitDate}</h4>
								</Grid>
								<Grid item md={6} sm={12} xs={12}>
									<Grid container spacing={2}>
										<Grid item md={4} xs={4} className='correctmarksbox' >
											{myData.correctMarks}<br/>
											Correct Mark
										</Grid>
										<Grid item md={4} xs={4} className='incorrectmarksbox' >
											{myData.incorrectMarks}<br/>
											Incorrect Mark
										</Grid>
										<Grid item md={4} xs={4} className='notanswermarksbox' >
											{myData.notAnsweredMarks}<br/>
											Not Answer Mark
										</Grid>
									</Grid>
								</Grid>
							</Grid>
					</Box>

					<Box mt={1} className='anylyticbox' >
							<Grid container spacing={2}>

							
								<Grid item md={12} xs={12}>
								{(myData.testType!=null && myData.testType!=1)?
									<h2>Dear {myData.studentName}, You got <i>{myData.rank}</i> rank among <i>{myData.totalStudent}</i> students</h2>
								:<br/>}	
								</Grid>							

								<Grid item md={4} sm={12} xs={12} className='lrpadding' >
									<Grid container spacing={2}>
										<Grid item md={6} sm={6} xs={6} >
											<h4>MARKS SCORED</h4>
										</Grid>
										<Grid item md={6} sm={6} xs={6} className='rightalign' >
											<h3>{myData.marksObtain}/{myData.fullMarks}</h3>
										</Grid>	
									</Grid>
									<BorderLinearProgress variant="determinate" value={myData.percentageMarks} />
									<h3>{myData.percentageMarks}%</h3>
								</Grid>

								<Grid item md={4} sm={12} xs={12} className='lrpadding' >
									<Grid container spacing={2}>
										<Grid item md={6} sm={6} xs={6} >
											<h4>PERCENTILE</h4>
										</Grid>
										<Grid item md={6} sm={6} xs={6} className='rightalign' >
											<h3>{myData.percentile}%</h3>
										</Grid>	
									</Grid>
									<BorderLinearProgress variant="determinate" value={myData.percentile} />
									<h3>{myData.percentile}%</h3>
								</Grid>
								
								<Grid item md={4} sm={12} xs={12} className='lrpadding' >
									<Grid container spacing={2}>
										<Grid item md={8} sm={8} xs={8} >
											<h4>TIME SPENT (Min)</h4>
										</Grid>
										<Grid item md={4} sm={4} xs={4} className='rightalign' >
											<h3>{myData.timeSpentMinutes}/{myData.totalTime}</h3>
										</Grid>	
									</Grid>
									<BorderLinearProgress variant="determinate" value={myData.percentageTime} />
									<h3>{myData.percentageTime}%</h3>
								</Grid>

							</Grid>
					</Box>


					<Box mt={1} sx={{ width: '100%', typography: 'body1' }}>
						<TabContext value={value}>
							<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
							<TabList onChange={handleChange} centered variant="scrollable" scrollButtons="auto" aria-label="lab API tabs example">
								<Tab label="Overall Performance" value="1" />
								<Tab label="View Answers" value="4" />
								<Tab label="Time Management" value="2" />
								<Tab label="Inferences" value="3" />
								
							</TabList>
							</Box>
							<TabPanel value="1"></TabPanel>
							<TabPanel value="2"></TabPanel>
							<TabPanel value="3"></TabPanel>
						</TabContext>
					</Box>
					

					{(progressBarFlag && progressBarFlag>0)?						
						<Box style={{marginTop:-50}} >
							<Grid container spacing={2}>
								<Grid item xs={12} style={{textAlign:'center'}} ><h3>Progress Bar</h3></Grid>
							</Grid>
							<Grid container spacing={2}>
								<Grid item md={4} sm={4} xs={12} ></Grid>
								<Grid item md={4} sm={4} xs={12} >
									<h1 style={{textAlign:'center', color:progressBarColor}}>{progressBar}%</h1>
									<ProgressBarGraph variant="determinate" value={progressBar} />
									{progressBarRemarks?<div style={{textAlign:'center'}}>{progressBarRemarks}</div>:null}
								</Grid>
								<Grid item md={4} sm={4} xs={12} ></Grid>
							</Grid>
						</Box>
					:null}

					{/********************  Self Test ****************************/}
					{/********************  Overall Performance ****************************/}
					<Box id="taboneboxid" mt={1}>
						<Grid container spacing={2}>
							
						{(myData.helpCounter && myData.helpCounter>0)?	
							<Grid item   md={12} xs={12} >
								<h3 style={{textAlign:'center',color:'#FF0000'}}>Questions solved with help: {myData.helpCounter}/{myData.totalQuestion}</h3>
							</Grid>
						:null}	

							<Grid item   md={4} xs={12} >
								<HighchartsReact
									highcharts={Highcharts}
									options={chartOneData}
								/>							
							</Grid>
							<Grid item   md={4} xs={12} >
								{<HighchartsReact
									highcharts={Highcharts}
									options={chartTwoData}
								/>}
							</Grid>
							<Grid item   md={4} xs={12} >
								<HighchartsReact
									highcharts={Highcharts}
									options={chartThreeData}
								/>
							</Grid>

						</Grid>

					</Box>

					{/********************  Time Management ****************************/}
					<Box id="tabtwoboxid" style={{display:'none'}} mt={1}>
						<Grid container spacing={2}>												
							<Grid item   md={4} xs={12} >
								<HighchartsReact
									highcharts={Highcharts}
									options={chartFourData}
								/>								
							</Grid>
							<Grid item   md={4} xs={12} >
								{<HighchartsReact
									highcharts={Highcharts}
									options={chartFiveData}
								/>}
							</Grid>
							<Grid item   md={4} xs={12} >
								<TableContainer component={Paper}>
									<Table aria-label="simple table">
										<TableBody>										
											<TableRow>
												<TableCell >Total time</TableCell>
												<TableCell >{myData.totalTimeLabel}</TableCell>
											</TableRow>
											<TableRow>
												<TableCell >Time taken</TableCell>
												<TableCell >{myData.spentTimeLabel}</TableCell>
											</TableRow>
											<TableRow>
												<TableCell >Time remaining</TableCell>
												<TableCell >{myData.remainingTimeLabel}</TableCell>
											</TableRow>
											<TableRow>
												<TableCell >Avg available time</TableCell>
												<TableCell >{myData.averageTimePerQuestionLabel}</TableCell>
											</TableRow>
											<TableRow>
												<TableCell >Avg. Speed per Question</TableCell>
												<TableCell >{myData.averageSpeedPerQuestionLabel}</TableCell>
											</TableRow>
										</TableBody>
									</Table>
								</TableContainer>
							</Grid>

						</Grid>
					</Box>

					{/********************  Inferences ****************************/}
					<Box id="tabthreeboxid" style={{display:'none'}} mt={1}>
						<Grid container spacing={2}>		
							<Grid item   md={12} xs={12} >
								<h2 style={{textAlign:'center',textTransform:'uppercase'}} >Overall Knowledge</h2>	
							</Grid>										
							<Grid item   md={4} xs={12} >
								<HighchartsReact
									highcharts={Highcharts}
									options={chartSixData}
								/>	
							</Grid>
							<Grid item   md={4} xs={12} >
								{<HighchartsReact
									highcharts={Highcharts}
									options={chartSevenData}
								/>}
							</Grid>
							<Grid item   md={4} xs={12} >
								<TableContainer component={Paper}>
									<Table aria-label="simple table">
										<TableBody>										
											<TableRow>
												<TableCell >Total Questions</TableCell>
												<TableCell >{myData.totalQuestion}</TableCell>
											</TableRow>
											<TableRow>
												<TableCell >Question Corrected</TableCell>
												<TableCell >{myData.correctAnswers}</TableCell>
											</TableRow>
											<TableRow>
												<TableCell >Full Marks</TableCell>
												<TableCell >{myData.fullMarks}</TableCell>
											</TableRow>
											<TableRow>
												<TableCell >Marks Obtained</TableCell>
												<TableCell >{myData.marksObtain}</TableCell>
											</TableRow>
										</TableBody>
									</Table>
								</TableContainer>
							</Grid>

						</Grid>


						<Grid container spacing={2}>		
							<Grid item   md={12} xs={12} >
								<h2 style={{textAlign:'center',textTransform:'uppercase'}} >Accuracy of Attempted</h2>	
							</Grid>										
							<Grid item   md={6} xs={12} >
								<HighchartsReact
									highcharts={Highcharts}
									options={chartEightData}
								/>	
							</Grid>
							<Grid item   md={6} xs={12} >
								<TableContainer component={Paper}>
									<Table aria-label="simple table">
										<TableBody>										
											<TableRow>
												<TableCell >Attempted Questions</TableCell>
												<TableCell >{myData.attemptedQuestions}</TableCell>
											</TableRow>
											<TableRow>
												<TableCell >Correct Questions</TableCell>
												<TableCell >{myData.correctAnswers}</TableCell>
											</TableRow>
											<TableRow>
												<TableCell >Incorrect Questions</TableCell>
												<TableCell >{myData.incorrectAnswers}</TableCell>
											</TableRow>
										</TableBody>
									</Table>
								</TableContainer>
							</Grid>

						</Grid>


					</Box>

				</Box>
				</main>					
		</div>	
	);
  }